import { PostsProps } from "../posts/Posts";

const addOneLike = (Likes: PostsProps.Count) => {
  const newLikes = parseInt(`${Likes}`);

  if (isNaN(newLikes)) return Likes;
  return newLikes + 1;
};
const removeOneLike = (Likes: PostsProps.Count) => {
  const newLikes = parseInt(`${Likes}`);

  if (isNaN(newLikes)) return Likes;
  return newLikes - 1;
};
const addOneDislike = (Dislikes: PostsProps.Count) => {
  const newDislikes = parseInt(`${Dislikes}`);

  if (isNaN(newDislikes)) return Dislikes;
  return newDislikes + 1;
};
const removeOneDislike = (Dislikes: PostsProps.Count) => {
  const newDislikes = parseInt(`${Dislikes}`);

  if (isNaN(newDislikes)) return Dislikes;
  return newDislikes - 1;
};

export const LikesUtils = {
  addOneLike,
  removeOneLike,
  addOneDislike,
  removeOneDislike,
};
